import { Icon } from '@shared/components/Icon';
import { Text } from '@shared/components/Text';
import { ButtonView, View } from '@shared/components/View';
import { i18n } from '@shared/util/i18n';
import styles from './SubformRow.module.css';

interface AddSubformRowProps {
  onAdd(): void;
}

export function AddSubformRow({ onAdd }: AddSubformRowProps) {
  return (
    <ButtonView fullWidth className={styles.row} onClick={onAdd}>
      <View row centerVertically paddingVertical={1} paddingHorizontal={3}>
        <Icon name="plus" gridSize={2.75} />
        <View fill centerVertically paddingLeft={1}>
          <Text size="body1">{i18n('workflowTemplate.createNewSubform')}</Text>
        </View>
      </View>
    </ButtonView>
  );
}
